export const environment = {
    production: true,
    dev: false,
    test: false
};
